// Bowdoin College's majors (#2739). Read on 2026-10-01 from the official
// Bowdoin College Catalogue and Academic Handbook, 2026-2027 Edition,
// Departments and Programs (catalog.bowdoin.edu, which opens the catalogue on
// Bowdoin's CourseLeaf host, where the department pages are): every major each department or program page lists,
// plus the Interdisciplinary Majors page. Bowdoin awards the bachelor of
// arts. The three coordinate majors (Digital and Computational Studies,
// Education, Environmental Studies) are taken with a second major. Minors,
// the Creative Writing concentration in English, and the minor-only programs
// (Cinema Studies, Middle Eastern and North African Studies, Urban Studies)
// are left out.
const majors = {
    "slug": "bowdoin-college",
    "read": "2026-10-01",
    "intro": "Every major in Bowdoin's official 2026-2027 Catalogue, including its interdisciplinary and coordinate majors, each leading to the bachelor of arts. Minors are left out.",
    "groups": [
        {
            "name": "Department and program majors",
            "source": {
                "label": "Bowdoin Catalogue 2026-2027, Departments and Programs",
                "url": "https://catalog.bowdoin.edu/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Digital and Computational Studies (coordinate major)",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Oceanographic Science",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Education (coordinate major)",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies (coordinate major)",
                    "degree": "B.A."
                },
                {
                    "name": "Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Sexuality, and Women's Studies",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Government and Legal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Hispanic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American, Caribbean, and Latinx Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Languages and Literatures",
                    "degree": "B.A."
                },
                {
                    "name": "Russian, East European, and Eurasian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Theater and Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Interdisciplinary majors",
            "source": {
                "label": "Bowdoin Catalogue 2026-2027, Interdisciplinary Majors",
                "url": "https://catalog.bowdoin.edu/"
            },
            "majors": [
                {
                    "name": "Art History and Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Art History and Visual Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Chemical Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science and Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics and Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "English and Theater",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Education",
                    "degree": "B.A."
                },
                {
                    "name": "Physics and Education",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
